import { css } from '@emotion/react';
import styled from '@emotion/styled';
import ArrowNext from '@engineering/icons/arrow-next';
import ArrowLast from '@engineering/icons/arrow-last';
import { Button, SecondaryText } from '@silvertours/front-shared';

export const CarouselWrapper = styled.section`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  position: relative;
`;

export const SlideWrapper = styled.div`
  display: flex;
  width: 100%;
`;

export const ChildrenWrapper = styled.div<{ snap: boolean }>`
  padding-bottom: 2rem;
  width: max-content;
  height: max-content;

  ${({ snap }) =>
    snap &&
    `
  & > * {
    scroll-snap-align: center;
  }
`};
`;

export const CarouselSlide = styled.div<{ snap: boolean }>`
  flex: 0 0 auto;
  overflow-x: auto;
  width: 100%;

  &::-webkit-scrollbar {
    display: none;
  }

  scrollbar-width: none;

  ${({ snap }) => snap && 'scroll-snap-type: x mandatory;'};
`;

export const IndicatorsWrapper = styled.div`
  display: flex;
  justify-content: center;
  padding-bottom: ${({ theme }) => theme.spacing[20]};
`;

export const Indicator = styled.div<{ active: boolean }>`
  width: 0.5rem;
  height: 0.5rem;
  border-radius: 50%;
  background-color: ${({ active, theme }) =>
    active ? theme.color.brand : theme.color.grey03};
  margin: 0 0.25rem;
  cursor: pointer;
`;

export const ButtonWrapper = styled.div`
  align-self: end;
  display: flex;
  flex-direction: row;
  gap: 1rem;
  margin-top: -1rem;
  margin-right: 1rem;
`;

export const SliderButton = styled(Button)`
  padding: 0.375rem;
`;

const ArrowIcon = css`
  width: 2.5rem;
  height: 2.5rem;
  flex-shrink: 0;
`;

export const ArrowNextIcon = styled(ArrowNext)`
  ${ArrowIcon};
`;

export const ArrowBackIcon = styled(ArrowLast)`
  ${ArrowIcon};
`;

export const CardBackground = styled.div<{ showSlideBackground: boolean }>`
  width: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  text-align: center;
  ${({ showSlideBackground, theme }) =>
    showSlideBackground
      ? `
      background-color: ${theme.color.grey05};
      border-radius: ${theme.borderRadius.md};
`
      : ''};
`;

export const Caption = styled(SecondaryText)`
  font-weight: 400;
  text-align: center;

  ${({ theme }) => theme.mq('md')} {
    position: absolute;
    bottom: 0.5rem;
    left: 50%;
    transform: translateX(-50%);
  }

  ${({ theme }) => theme.mq('lg')} {
    font-weight: 400;
  }
`;
